module.exports = __webpack_public_path__ + "img/nach-preview.658cdc61.jpg";